import { capSQLiteVersionUpgrade } from '@capacitor-community/sqlite/src/definitions';
import { v1UpgradeStatements } from './v1-upgrade.statements';
import { v2UpgradeStatements } from './v2-upgrade.statements';
import { v3UpgradeStatements } from './v3-upgrade.statements';

export class DbUpgradeStatements
{
    static getUpgradeStatements(): capSQLiteVersionUpgrade[]
    {
        return [
            {
                toVersion: 1,
                statements: [
                    ...v1UpgradeStatements,
                ],
            },
            {
                toVersion: 2,
                statements: [
                    ...v2UpgradeStatements,
                ],
            },
            {
                toVersion: 3,
                statements: [
                    ...v3UpgradeStatements,
                ],
            },
        ];
    }
}
